import { useState, useEffect } from 'react'
import { useQueryParam, StringParam, withDefault } from 'use-query-params'

import { getSavedState, parseQueryParam, saveState, toQueryParam } from './utils'

interface UseSavedQueryParamArgs<T extends {}> {
  storageKey: string
  defaultState: T
}

const useSavedQueryParam = <T extends {}>({
  storageKey,
  defaultState,
}: UseSavedQueryParamArgs<T>) => {
  const QueryParamConfig = withDefault(
    StringParam,
    toQueryParam(getSavedState(storageKey, defaultState)),
  )

  const [queryParam, setQueryParam] = useQueryParam(storageKey, QueryParamConfig)

  const initialState = parseQueryParam<T>(queryParam)

  const [state, setState] = useState<T>(initialState)

  const onSaveQueryParamValue = (newCommittedSearch: T) => {
    setState(newCommittedSearch)
    setQueryParam(toQueryParam(newCommittedSearch))
  }

  useEffect(() => {
    saveState(storageKey, parseQueryParam(queryParam))
  }, [storageKey, queryParam])

  return {
    queryParamValue: state,
    onSaveQueryParamValue,
  }
}

export default useSavedQueryParam
